module.exports = __webpack_public_path__ + "img/sv71on.73eec70e.svg";